import { getFirstLetter } from "utils";

export const groupDataByLetter = (dataList, groupField) => {
  if (!dataList || dataList.length === 0) return [];

  const handleContactsObj = dataList.reduce((newContactList, contact) => {
    const firstLetter = contact[groupField] ? getFirstLetter(contact[groupField]).toUpperCase() : "#";
    newContactList[firstLetter] = (newContactList[firstLetter] || []).concat(contact);

    return newContactList;
  }, {});

  return handleContactsObj;
};
